import { FeatureFlags } from '@domain/types';
import { createContext, useContext } from 'react';

const EMPTY_FLAGS: FeatureFlags = {};

export const FeatureFlagsContext = createContext<FeatureFlags>(EMPTY_FLAGS);

export const useFeatureFlags = (): FeatureFlags => useContext(FeatureFlagsContext);

// Kept apart from the flags so that a spec providing flags does not have to know about loading.
// Loading until a provider says otherwise, as user.featureFlags.loading was in the initial state.
export const FeatureFlagsLoadingContext = createContext<boolean>(true);

export const useAreFeatureFlagsLoading = (): boolean => useContext(FeatureFlagsLoadingContext);
